import { EAIChatPageId } from 'types/ai';
import { isLocalhost } from 'utils/common';
import { Request } from '../request';

export const baseURL = isLocalhost() ? 'https://dev.boxpractice.com/ai-server/klarity-engagement-engine/' : `${window.location.origin}/ai-server/klarity-engagement-engine/`;
// export const baseURL = isLocalhost() ? 'https://test.boxpractice.com/' : `${window.location.origin}/`;
// export const baseURL = isLocalhost() ? 'https://app.kiwihealth.com/' : `${window.location.origin}/`;
// eslint-disable-next-line wrap-iife

//Hackathon
export const getBotAnswer = ({ text, userid, url }: { text: string, userid: string, url?: string }) =>
    Request.post({
        url: url ?? 'https://onwish.co/brewery/chat/',
        params: {
            userid,
            text,
            chatbot_id: 'klarity-front-desk',
        },
        disableToken: true,
    });

export const getRandomUser = () =>
    Request.get({
        url: 'https://randomuser.me/api/',
    });

//Hackathon

export type TChatWithBotParams = {
    bot_id: string;
    user_input: string;
    user_id: string;
    file_ids?: string[];
    page_id?: EAIChatPageId;
};

export const chatWithBot = (params: TChatWithBotParams) =>
    Request.streamPost({
        url: `${baseURL}playground/chat`,
        params,
        disableErrorNote: true,
    });

export const uploadImage = (data: FormData) =>
    Request.post<FormData>(
        {
            url: `${baseURL}playground/upload/image`,
            params: data,
            config: {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            },
        },
    );

export type TGetHistory = {
    user_id: string,
    date_str: string, //Date in YYYYMMDD format - returns messages for this specific date
};

export const getHistoryMessage = (params: TGetHistory) =>
    Request.get({
        url: `${baseURL}playground/chat/history/${params.user_id}`,
        params: {
            date_str: params.date_str,
        },
        disableErrorNote: true,
    });

export type TFeedbackMessage = {
    bot_id: string;
    bot_name: string;
    user_question: string;
    ai_answer: string;
    feedback_type?: 'positive' | 'negative';
    comment?: string;
    bot_version: string;
    message_id?: string;
};

export const feedbackMessage = (params: TFeedbackMessage) =>
    Request.post({
        url: `${baseURL}playground/chat-feedback`,
        params,
    });

export const getSuggestedQuestions = (contextId: EAIChatPageId) =>
    Request.get({
        url: `${baseURL}ai-studio/page-context/${contextId}/suggested-questions`,
        disableErrorNote: true,
    });
